
var stache = require('can/view/stache/stache');
module.exports = stache("<div class=\"m-custom-merchandise\">\r\n    <custom-merchandise {merchandise}=\"products\" {cta-link}=\"productsCtaLink\" />\r\n</div>\r\n");